import store from "../../redux/store";
import Functions from "../Functions";
import { PermissionTypes } from "../Enums";

function GetHasStarta(avdid) {
  var state = store.getState();
  if (!state || !state.user.user || !state.user.user.id) return false;
  if (!avdid) return false;
  const avd = state.user.user.avdelnings.find((obj) => {
    return obj.id === avdid;
  });
  if (!avd) return false;
  return Functions.hasFlag(avd.permission, PermissionTypes.Starta);
}

store.subscribe(GetHasStarta);

export default GetHasStarta;
